var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LockUnlockedIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15C12 13.8954 12.8954 13.5 14 13.5C15.1046 13.5 16 14.3954 16 15.5C16 16.2403 15.5978 16.8866 15 17.2324V18.0009C15 18.5527 14.5561 19 14 19C13.4477 19 13 18.5566 13 18.0009V17.2324C12.4022 16.8866 12 15.7403 12 15ZM10 10V8.00026C10 5.7922 8.20838 4 6 4C3.79049 4 2 5.7907 2 8.00016V9.49887C2 10.0548 1.55228 10.5021 1 10.5021C0.443865 10.5021 0 10.0529 0 9.49887V8.00016C0 4.68618 2.68587 2 6 2C9.3131 2 12 4.68778 12 8.00026V10H19.9979C21.1036 10 22 10.8928 22 12.0031V19.9969C22 21.1032 21.1055 22 19.9979 22H8.00213C6.89638 22 6 21.1072 6 19.9969V12.0031C6 10.8968 6.89451 10 8.00213 10H10ZM8 12V20H20V12H8Z", fill: "" })));
}
export var LockUnlockedIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LockUnlockedIconInner }, props))); };
//# sourceMappingURL=LockUnlockedIcon.js.map